function adjustEmptyCartWidth() {
  
  const csCartItemsContainer = document.querySelector('.cart-items')
  const csCartItemsParent = csCartItemsContainer.closest('.shopify-section')
  // console.log(csCartItemsContainer);
  
  if (csCartItemsContainer.classList.contains('is-empty')) {
    csCartItemsParent.style.width = '100%';
  } else {
    if (csCartItemsParent) {
      csCartItemsParent.style.width = '60%';
    }
  }

}

document.addEventListener('DOMContentLoaded', function() {
  adjustEmptyCartWidth()
})

function discountOnCheckout() {       
    setTimeout(function(){      
        const csCheckoutButton = document.getElementById('cs-checkout')
        const csCartForm = document.getElementById('CartDrawer-Form')

        if (csCheckoutButton) {
          csCheckoutButton.addEventListener('click', function(e) {
              e.preventDefault()
              var discountCode = 'FREESHIPPING';
              var redirectUrl = '/checkout';
              csCartForm.submit()
              window.location.href = '/discount/' + discountCode + '?redirect=' + encodeURIComponent(redirectUrl);
              // console.log('checkout clicked')
          })
        }
    }, 100)
}

discountOnCheckout()

class CartWatcher {

    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
      });
    }
  
    async fetchCart() {
      const response = await fetch('/cart.js');
      return response.json();
    }
  
    storeCart(cart) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  
   storedCart() {
      return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }
  
   findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };
  
      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0
          ? result.added.push(item)
          : result.removed.push(item)
      });
  
      return result;
    }
  
    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
  
      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);
  
      this.storeCart(newCart);
    }
  
   observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  }

const myCartWatcher = new CartWatcher;
myCartWatcher.init();
window.addEventListener("cart_changed", e => {
    // console.log(e.detail)
    discountOnCheckout()
    adjustEmptyCartWidth()
});

// jquery preload

$(function(){

  var windowWidth = $(window).width()

  function csDropdown() {
    if (windowWidth <= 750) {
      $('.cs-dropdown').each(function() {
        $(this).on('click', function() {
          var thisDropdown = $(this)
          var nextUl = $(this).next('ul')   
          if (thisDropdown.hasClass('active')) {
            nextUl.slideUp(100)
            thisDropdown.removeClass('active')
          } else {
            nextUl.slideDown(100)
            thisDropdown.addClass('active')
          }
        })
      })
    }
  }

  csDropdown()

  // custom dropown
  
    // Check the window width on window resize
    $(window).resize(function() {
      windowWidth = $(window).width()
      // Perform specific actions if the width is less than or equal to 748px
      if (windowWidth <= 748) {
        csDropdown()
      }
    })
  })
/* Bottom mobile nav — rebind Shop / Reviews / Cart.
   The section's own script dies on a missing Swiper before it binds these. */
;(function () {
  if (window.__camBottomNavFix) return;
  window.__camBottomNavFix = true;

  function openPanel(which) {
    var drawer     = document.querySelector('.drawer');
    var shopList   = document.querySelector('div.shop-list');
    var reviewList = document.querySelector('div.review-list');

    if (which === 'cart') {
      reviewList && reviewList.classList.remove('open');
      shopList   && shopList.classList.remove('open');
      drawer     && drawer.classList.add('animate', 'active');
    } else if (which === 'shop') {
      drawer     && drawer.classList.remove('animate', 'active');
      reviewList && reviewList.classList.remove('open');
      shopList   && shopList.classList.add('open');
    } else if (which === 'reviews') {
      drawer     && drawer.classList.remove('animate', 'active');
      shopList   && shopList.classList.remove('open');
      reviewList && reviewList.classList.add('open');
    }
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.bottom-nav-item');
    if (item) {
      if (item.classList.contains('cart'))    { e.preventDefault(); openPanel('cart');    return; }
      if (item.classList.contains('shop'))    { e.preventDefault(); openPanel('shop');    return; }
      if (item.classList.contains('reviews')) { e.preventDefault(); openPanel('reviews'); return; }
    }
    var close = e.target.closest && e.target.closest('.bottom-nav-close');
    if (close && close.parentElement) close.parentElement.classList.remove('open');
  });
})();

/* Crab selector — out-of-stock state for the Add to Cart button.
   Only runs on the crab configurator page (#ccfg). Greys out the button and shows an
   "Out of stock" line whenever the selected variant is unavailable. On wide screens the
   Quantity box and button sit side by side, so the label goes on its own full-width line above
   that row (it never shifts the button out of line with Quantity). When the row stacks on
   mobile, the label goes directly above the button instead. */
;(function () {
  if (window.__camCrabOos) return;
  window.__camCrabOos = true;

  var style = document.createElement('style');
  style.textContent =
    '.ccfg-oos-label{display:flex;align-items:center;gap:.7rem;width:100%;margin:1.6rem 0 1rem;font-size:1.4rem;font-weight:600;letter-spacing:.04rem;line-height:1.2;color:#b3261e}' +
    '.ccfg-oos-label::before{content:"";flex:none;width:.8rem;height:.8rem;border-radius:50%;background:#b3261e}' +
    '.product-form__submit.ccfg-oos,.product-form__submit.ccfg-oos:hover{background-color:#eceef1 !important;border-color:#eceef1 !important;color:#a3a9b0 !important;cursor:not-allowed;box-shadow:none !important;transform:none !important}' +
    '.product-form__submit.ccfg-oos::before,.product-form__submit.ccfg-oos::after{display:none !important}';
  document.head.appendChild(style);

  var restoreText = null;

  function selectedVariant() {
    var dataEl = document.getElementById('ccfg-data');
    var idInput = document.querySelector('form[id^="product-form"] input[name="id"]');
    if (!dataEl || !idInput) return null;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    return data.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || null;
  }

  // Put the label where it belongs for the current layout. Side by side: above the whole row.
  // Stacked: directly above the button's own block.
  function placeLabel(label, btn) {
    var row = btn.closest('.two-column-blocks');
    var block = btn.closest('product-form') || btn.closest('.product-form__buttons') || btn;
    var stacked = !row || block.getBoundingClientRect().width > row.getBoundingClientRect().width * 0.9;
    var anchor = stacked ? block : row;
    if (label.nextElementSibling !== anchor) anchor.parentNode.insertBefore(label, anchor);
    label.style.marginTop = stacked ? '1.2rem' : '';
  }

  function sync() {
    if (!document.getElementById('ccfg')) return;
    var variant = selectedVariant();
    var btn = document.querySelector('form[id^="product-form"] [name="add"]');
    if (!variant || !btn) return;
    var textEl = btn.querySelector('span');
    var label = document.querySelector('.ccfg-oos-label');

    if (!restoreText && !btn.disabled && textEl) restoreText = textEl.textContent;

    if (!variant.available) {
      if (!label) {
        label = document.createElement('div');
        label.className = 'ccfg-oos-label';
        label.setAttribute('role', 'status');
        label.textContent = 'Out of stock';
      }
      placeLabel(label, btn);
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('ccfg-oos');
    } else {
      if (label) label.remove();
      if (btn.classList.contains('ccfg-oos')) {
        btn.classList.remove('ccfg-oos');
        btn.removeAttribute('disabled');
        if (textEl) textEl.textContent = restoreText || (window.variantStrings && window.variantStrings.addToCart) || 'Add to Cart';
      }
    }
  }

  function syncSoon() { setTimeout(sync, 60); }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#ccfg')) syncSoon();
  });
  document.addEventListener('change', syncSoon);
  window.addEventListener('resize', syncSoon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncSoon);
  else syncSoon();
  window.addEventListener('load', syncSoon);
})();
  